
export const formFields = {
    ionAccountID: {
        key: 'ionAccountID',
        label: 'Account ID',
        placeholder: '',
        required: true,
        requiredMessage: 'This field is required.',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 characters allowed.',
        displayLayout: 'col-md-7',
        tooltip: '<div> Account ID </div>',
        pattern: /^\d{0,100}$/
    },
    ionCurrency: {
        key: 'ionCurrency',
        label: 'Currency',
        placeholder: '',
        type: "text",
        displayLayout: 'col-md-7',
        valueKey: 'key',
        required: true,
        requiredMessage: 'This field  is required.',
        textKey: 'value',
        tooltip: '<div>  Currency </div>',
        pattern: /^[A-Z]*$/
    },
    addTypeDv360: {
        key: 'addTypeDv360',
        label: '',
        placeholder: '',
        required: true,
        displayLayout: 'col-sm-12',
        requiredMessage: 'This field is required.',
        options: [{ id: 1, value: 'Link DV 360 Account', checked: false },
        { id: 0, value: 'Use Infomo' }],
      }
}

export const radioBtn = [
    { key: "1", value: "Manually Enter Account Details", checked: false },
    { key: "2", value: "Link Facebook Account", checked: false },
]